import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { Functionality } from '../context/Functionality';
import { readableDate } from './blog/Article';
export default function BlogTable() {
    const { blogs } = useContext(Functionality);
    const posts = blogs.blogs || [];
    const [page, setPage] = useState(1);
    const current = Math.min(page, Math.max(1, Math.ceil(posts.length / 8)));
    if (!posts.length) return <p>No articles yet. Create your first draft.</p>;
    return <><div className="overflow-x-auto"><table className="min-w-full text-left">
        <thead><tr>{['Title', 'Status', 'Author', 'Last modified', 'Actions'].map(label => <th className="p-3 border-b" key={label}>{label}</th>)}</tr></thead>
        <tbody>{posts.slice((current - 1) * 8, current * 8).map(post => <tr key={post._id}>
            <td className="p-3 border-b">{post.title || 'Untitled draft'}</td><td className="p-3 border-b">{post.status === 'published' ? 'Published' : 'Draft'}</td>
            <td className="p-3 border-b">{post.author || '—'}</td><td className="p-3 border-b">{readableDate(post.updatedAt) || '—'}</td>
            <td className="p-3 border-b"><div className="blog-actions"><Link to={`/add-blog/${post._id}`}>Edit</Link><Link to={`/blog-preview/${post._id}`}>Preview</Link>
                {post.status === 'published' && <a href={`/blog/${post.slug}`}>View Public Page</a>}
            </div></td>
        </tr>)}</tbody>
    </table></div><div className="blog-actions"><button disabled={current === 1} onClick={() => setPage(current - 1)}>Previous</button><span>Page {current} of {Math.ceil(posts.length / 8)}</span><button disabled={current * 8 >= posts.length} onClick={() => setPage(current + 1)}>Next</button></div></>;
}
